import { BusinessTimeType, OpenTimeType, ShoppingBagType, StoreType } from 'types/store'
import { DayOfWeekType } from 'lib/daysOfWeek'

export const FETCH_STORES = 'FETCH_STORES'
export const fetchStoresAction = (stores: StoreType[]) => {
  return {
    type: 'FETCH_STORES',
    payload: stores,
  }
}

export const SAVE_STORE_INFORMATION = 'SAVE_STORE_INFORMATION'
export const saveStoreInformationAction = (store: StoreType) => {
  return {
    type: 'SAVE_STORE_INFORMATION',
    payload: store,
  }
}

export const SET_STORE = 'SET_STORE'
export const setStoreAction = (store: StoreType) => {
  return {
    type: 'SET_STORE',
    payload: store,
  }
}

export const UPDATE_PUBLISH_FIRST_STOCK = 'UPDATE_PUBLISH_FIRST_STOCK'
export const updatePublishFirstStockAction = () => {
  return {
    type: 'UPDATE_PUBLISH_FIRST_STOCK',
    payload: {
      is_before_publishing_stock: false,
    },
  }
}

export const UPDATE_BUSINESS_HOURS = 'UPDATE_BUSINESS_HOURS'
export const updateBusinessHoursAction = ({
  holidays,
  business_hours,
  last_order_time,
  last_pickup_time,
  order_start_time,
}: {
  holidays: DayOfWeekType[]
  business_hours: OpenTimeType
  last_order_time: BusinessTimeType
  last_pickup_time: BusinessTimeType
  order_start_time: BusinessTimeType
}) => {
  return {
    type: 'UPDATE_BUSINESS_HOURS',
    payload: {
      holidays,
      business_hours,
      last_order_time,
      last_pickup_time,
      order_start_time,
    },
  }
}

export const UPDATE_SHOPPING_BAGS = 'UPDATE_SHOPPING_BAGS'
export const updateShoppingBagsAction = (shoppingBags: ShoppingBagType[]) => {
  return {
    type: 'UPDATE_SHOPPING_BAGS',
    payload: shoppingBags,
  }
}

export const INIT_STORE = 'INIT_STORE'
export const initStoreAction = () => {
  return {
    type: 'INIT_STORE',
    payload: null,
  }
}
